import { createActionTypes } from "./GenericActions";

const createGenericReducer = (entityName, tableName) => {
  const actionTypes = createActionTypes(entityName, tableName);
  return (
    state = { data: [], loading: false, error: null, total: 0 },
    action
  ) => {
    switch (action.type) {
      case actionTypes.FETCH_REQUEST:
      case actionTypes.CREATE_REQUEST:
      case actionTypes.UPDATE_REQUEST:
      case actionTypes.DELETE_REQUEST:
        return { ...state, loading: true, error: null };
      case actionTypes.FETCH_SUCCESS:
        return {
          ...state,
          loading: false,
          data: action.payload.data,
          total: action.payload.total,
        };
      case actionTypes.CREATE_SUCCESS:
        return {
          ...state,
          loading: false,
          data: [...state.data, action.payload],
          total: state.total + 1,
        };
      case actionTypes.UPDATE_SUCCESS:
        return {
          ...state,
          loading: false,
          data: state.data.map((item) =>
            item.ptsCodeId === action.payload.ptsCodeId ? action.payload : item
          ),
        };
      case actionTypes.DELETE_SUCCESS:
        return {
          ...state,
          loading: false,
          data: state.data.filter((item) => item.ptsCodeId !== action.payload),
          total: state.total - 1,
        };
      case actionTypes.FETCH_FAILURE:
      case actionTypes.CREATE_FAILURE:
      case actionTypes.UPDATE_FAILURE:
      case actionTypes.DELETE_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
};

export default createGenericReducer;
